module.exports = __webpack_public_path__ + "img/creative-commons-sampling-plus.80e20687.svg";